// src/components/EmptyOrderPage.tsx

import React from 'react';

// You would replace this with your actual illustration, 
// but for simplicity, we'll use a placeholder SVG that represents documents/orders.
const ClipboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-24 h-24 sm:w-32 sm:h-32 text-gray-400/80"
  >
    {/* Clipboard base */}
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" className="fill-gray-200 stroke-gray-400" />
    {/* Page 1 (behind) */}
    <rect x="5" y="6" width="14" height="15" rx="2" ry="2" className="fill-white stroke-gray-400" />
    <line x1="8" y1="9" x2="16" y2="9" className="stroke-gray-400/70" />
    <line x1="8" y1="12" x2="16" y2="12" className="stroke-gray-400/70" />
    <line x1="8" y1="15" x2="16" y2="15" className="stroke-gray-400/70" />
    {/* Page 2 (front, slightly tilted) - More stylized like the image */}
    <g transform="translate(1 1)" className="text-[#a5885c]"> {/* Adjusted color for the light tan/brown feel */}
        <rect x="3" y="4" width="12" height="14" rx="2" ry="2" className="fill-white stroke-current opacity-80" style={{ transform: 'rotate(-5deg)', transformOrigin: 'center' }} />
        <line x1="6" y1="8" x2="12" y2="8" className="stroke-current" style={{ transform: 'rotate(-5deg)', transformOrigin: 'center' }} />
        <line x1="6" y1="11" x2="12" y2="11" className="stroke-current" style={{ transform: 'rotate(-5deg)', transformOrigin: 'center' }} />
        <line x1="6" y1="14" x2="12" y2="14" className="stroke-current" style={{ transform: 'rotate(-5deg)', transformOrigin: 'center' }} />
    </g>
  </svg>
);


const EmptyOrderPage: React.FC = () => {
  return (
    // Outer container for centering content on the page
    <div className="flex items-start justify-center min-h-screen bg-gray-50 ">
      
      {/* The main content box */}
      <div className="flex flex-col items-center max-w-lg p-8 text-center bg-white rounded-lg">
        
        {/* 1. Illustration/Image */}
<div className="">
  <img
    src="https://www.shutterstock.com/image-vector/jewelry-shop-display-gold-necklaces-260nw-2491599809.jpg"   // 🖼️ Replace with your actual image path
    alt="Illustration"
    className="w-64 h-64 mx-auto object-contain"
  />
</div>


        {/* 2. Main Message */}
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-700 mb-4">
          You haven't placed any order yet!
        </h2>

        {/* 3. Sub Text / Explanation */}
        <p className="text-base text-gray-500 mb-8 max-w-md">
          Order section is empty. After placing order, you can track them from here!
        </p>

        {/* 4. Call-to-Action Button */}
        <a 
          href="/" // Replace with your actual shopping page route
          className="
            inline-flex 
            items-center 
            justify-center 
            px-12 py-3 
            text-base font-medium 
            rounded-md 
            text-white 
            bg-[#a5885c] hover:bg-[#8e7552] focus:outline-none 
            focus:ring-2 focus:ring-offset-2 focus:ring-[#a5885c]
            transition duration-150 ease-in-out
          "
        >
          Continue Shopping
        </a>
      </div>
    </div>
  );
};

export default EmptyOrderPage;